import { Directive, AfterViewInit } from 'angular-ts-decorators';

import { Domain } from '../services/domain';

/**
 * Link between apps:
 *
 * <code><pre>
 * <a sw-href="login#/login">
 * TURNS TO: <a sw-href="login#/login" href="https://www.dev.../login.html#/login">
 * </pre></code>
 */
@Directive({
  selector: '[sw-href]',
  priority: 99, // same as ngHref
})
export class SwHrefDirective implements AfterViewInit {
  constructor(
    private domain: Domain,
    private $attrs: ng.IAttributes,
    private $timeout: ng.ITimeoutService,
  ) {
    'ngInject';

    // TODO move to a parent class V6CompatibleDirective
    if (angular.version.minor < 5) {
      this.$timeout(() => {
        this.ngAfterViewInit();
      });
    }
  }

  ngAfterViewInit() {
    this.$attrs.$observe('swHref', (value: string) => {
      if (!value) {
        return;
      }

      this.$attrs.$set('href', this.domain.link(value));
    });
  }
}
